export default __webpack_public_path__ + "static/media/gamma_infinity.da35653f.png";